import React from 'react'
import LinesEllipsis from 'react-lines-ellipsis'
import { COUNT_EVENT_OF_CURRENT_DAY_BY_VEHICLE_UPDATED } from '../query/event'

class AllEventByVehicleComponent extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      count: this.props.events
    }
  }

  componentWillReceiveProps (nextProps) {
    // Update count when events prop changes (from polling)
    if (nextProps.events !== this.props.events) {
      this.setState({
        count: nextProps.events
      })
    }
  }

  // componentDidMount () {
  //   const self = this
  //   const currentDate = new Date()
  //   currentDate.setHours(0, 0, 0, 0)
  //   let trbImm = self.props.trbImm
  //   this.props.subscribeToMore({
  //     document: COUNT_EVENT_OF_CURRENT_DAY_BY_VEHICLE_UPDATED,
  //     variables: {
  //       occurred_at: currentDate,
  //       jsonFilter: {
  //         'trb_imm': trbImm
  //       }
  //     },
  //     updateQuery: (prev, { subscriptionData }) => {
  //       if (!subscriptionData.data) {
  //         return prev
  //       } else {
  //         this.setState({
  //           count: subscriptionData.data.events_aggregate.aggregate.count
  //         })
  //         return {
  //           events_aggregate: subscriptionData.data.events_aggregate
  //         }
  //       }
  //     }
  //   })
  // }

  render () {
    const self = this
    let countEventByVehicle = self.state.count
    return (
      <div>
        <div style={styles.paper}>
          <LinesEllipsis
            style={styles.title}
            text='TOUS LES EVENEMENTS'
            maxLine='1'
            ellipsis='...'
            trimRight
            basedOn='letters'
          />
          <div style={styles.content}>
            <span style={styles.number}>{countEventByVehicle}</span>
          </div>
          <div style={styles.labelContent}>
            <span style={styles.label}>Depuis minuit</span>
          </div>
        </div>
      </div>
    )
  }
}

const styles = {
  paper: {
    textAlign: 'left',
    backgroundColor: '#374147',
    height: '380px',
    borderRadius: '16px',
    paddingTop: '12px'
  },
  title: {
    marginLeft: '24px',
    marginTop: '6px',
    fontSize: '14px',
    fontWeight: 'bold',
    color: '#FFFFFF'
  },
  content: {
    textAlign: 'center',
    width: '100%',
    height: '80px',
    marginTop: '98px'
  },
  number: {
    fontSize: '70px',
    color: '#FFFFFF',
    fontWeight: 'bold'
  },
  labelContent: {
    textAlign: 'center',
    marginTop: '80px',
    width: '100%',
    height: '28px'
  },
  label: {
    fontSize: '16px',
    color: '#FFFFFF',
    fontWeight: 'bold'
  }
}

export default AllEventByVehicleComponent
